import { computed } from 'vue';
import { usePermission } from '@/entities/Permission';

/**
 * Every route of /matrix-models requires `manage:RecordManagement`, so an icon drawn under this
 * rule always concludes its action. There is no finer action for models today.
 */
export function useModelPermissions() {
  const { can } = usePermission();

  const canManageModels = computed(() => can('manage', 'RecordManagement').value);

  return {
    canRename: canManageModels,
    canDelete: canManageModels,
  };
}
